<template>
  <!-- 作業場所検索ダイアログ -->
  <v-dialog v-model="showDialog" width="70vw" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>過去取付作業場所一覧</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseButtonClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>

          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <dd-sub-header>
                検索条件
              </dd-sub-header>
              <span class="ml-1 view-description"><v-icon color="green" small>mdi-information-outline</v-icon>過去作業場所を絞り込みたい条件を入力して[検索実行]を押下してください。</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="6">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="取付先"
                    v-model="conditions.toritsukesakiNm"
                    ref="toritsukesakiNm"
                    :length="50"
                    :valueType="Ctrls.InputTypes.Free"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters align-content="center">
                <v-col :cols="12" class="px-1">
                  <v-toolbar class="pa-0 ma-0" flat dense>
                    <v-spacer />
                    <dd-default-button
                      class="ml-2"
                      min-width="80"
                      @click="onSearchButtonClick"
                    >
                      検索
                    </dd-default-button>
                  </v-toolbar>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row no-gutters align-content="center">
            <v-col :cols="8" class="px-1">
              <dd-sub-header>
                一覧
              </dd-sub-header>
              <span v-if="filteredRows.length > 0" class="ml-1 view-description"><v-icon color="green" small>mdi-information-outline</v-icon>対象行をチェックして[選択]を押下するか、ダブルクリックで呼び出し元画面に反映します。</span>
            </v-col>
            <v-col :cols="4" class="px-1">
              <dd-narrow-down-text-box
                v-model="sagyobashoSearchText"
                class="pt-4"
                :length="50"
              />
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="12" class="px-1">
              <dd-data-table
                calculate-widths
                item-key="id"
                :headers="sagyobashoHeaders"
                :items="filteredRows"
                height="50vh"
                fixed-header
                locale="ja-jp"
                :search="sagyobashoSearchText"
                no-data-text="利用可能なデータはありません。"
                hide-default-footer
                @dblclick:row="onRowDoubleClick"
                dense
              >
                <template v-slot:[`item.actions`]="{item}">
                  <template>
                    <v-chip
                      small
                      color="primary"
                      @click="onRowSelectButtonClick(item)"
                    >
                      選択
                    </v-chip>
                  </template>
                </template>
              </dd-data-table>
            </v-col>
          </v-row>

        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          tooltipText="選択せずに画面を閉じます"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
          @click="onCloseButtonClick">
          <v-icon>mdi-window-close</v-icon>
          閉じる
        </dd-footer-button>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdDataTable from '@/components/DdDataTable'
import DdTextBox from '@/components/DdTextBox'
import DdDefaultButton from '@/components/DdDefaultButton'

import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

import { mapGetters } from 'vuex'

export default {
  name: 'TgPopupSagyobashoSearchDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdNarrowDownTextBox,
    DdDataTable,
    DdTextBox,
    DdDefaultButton
  },
  props: {
    /**
     * 受注明細ID
     */
    id: {
      type: Number,
      default: 0
    },
    /**
     * 取付先名
     */
    toritsukesakiNm: {
      type: String
    },
    /**
     * 画面表示フラグ
     */
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    sagyobashoSearchText: '',
    rows: [],
    conditions: {
      id: 0,
      toritsukesakiNm: null
    },

    // ヘッダー
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    sagyobashoHeaders: [
      { text: '', value: 'actions', width: '15px' },
      { text: '取付先', value: 'toritsukesakiNm' },
      { text: '郵便番号', value: 'sagyobashoYubinNo' },
      { text: '住所1', value: 'sagyobashoJusho1' },
      { text: '住所2', value: 'sagyobashoJusho2' },
      { text: '住所3', value: 'sagyobashoJusho3' }
    ]
  }),
  created () {
  },
  mounted () {
    this.clear()
    // this.loadMasters()
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    filteredRows () {
      return this.rows.reduce((res, cur) => {
        if (res.every((elem) => elem.sagyobashoYubinNo !== cur.sagyobashoYubinNo ||
                                elem.sagyobashoJusho1 !== cur.sagyobashoJusho1 ||
                                elem.sagyobashoJusho2 !== cur.sagyobashoJusho2 ||
                                elem.sagyobashoJusho3 !== cur.sagyobashoJusho3)) {
          res.push(cur)
        }
        return res
      }, [])
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.conditions.id = this.id
        this.conditions.toritsukesakiNm = this.toritsukesakiNm
        this.search()
      }
    }
  },
  methods: {
    clear: function () {
      this.rows = []
      this.conditions = {
        id: 0,
        toritsukesakiNm: null
      }
    },
    loadMasters: function () {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['msttorihikisaki', 'mstshubetsu', 'msyskubun', 'msysmessage'], version: 1 }).then(() => {
      })
    },
    search: function () {
      console.log('VwCTgrcod001102 search')
      const self = this
      this.Effects.loadStart()
      return new Promise((resolve) => {
        self.HttpClient
          .post('/api/v1/VwCTgrcod001102/Search', self.conditions)
          .then((data) => {
            console.log('search', data)
            if (data.isValid) {
              self.rows = data.payload
            }
            this.Effects.loadComplete()
            resolve()
          }).catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            this.Effects.loadComplete()
          })
      })
    },
    onSearchButtonClick: function () {
      this.search()
    },
    onRowSelectButtonClick: function (item) {
      console.log('onRowSelectButtonClick', item)
      this.$emit('close', item)
    },
    onRowDoubleClick: function (e, f) {
      this.$emit('close', f.item)
      this.clear()
    },
    onCloseButtonClick: function (e) {
      this.$emit('close', null)
      this.clear()
    }
  }
}
</script>
<style>
</style>
